import { Button, Text } from '@mantine/core';

interface RadioButtonProps {
  selected: boolean;
  onClick: () => void;
  textChecked?: string;
  textUnchecked?: string;
}

export const RadioButton: React.FC<RadioButtonProps> = props => {
  return (
    <Button
      variant={props.selected ? 'filled' : 'outline'}
      onClick={props.onClick}
      style={{ width: 100 }}
    >
      <Text>
        {props.selected
          ? props.textChecked ?? 'Zvoleno'
          : props.textUnchecked ?? 'Zvolit'}
      </Text>
    </Button>
  );
};
